<template>
  <AlertBanner v-if="noRecords" :message="message"/>
</template>

<script>

import AlertBanner from '@/components/shares/AlertBanner.vue';

export default {
  name: 'TicketAlertBanner',
  components: { AlertBanner },
  data: () => ({
    records: [],
    loaded: false,
  }),
  computed: {
    noRecords() {
      return this.loaded && !this.records.length
    }
  },
  props: {
    message: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: true
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.axios.get(`${this.path}?per_page=1&meta=false`)
        .then(response => this.records = response.data)
        .finally(() => this.loaded = true)
    }
  }
}

</script>

<style scoped>

</style>